import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-landing-page-card',
    templateUrl: './landing-page-card.component.html',
    styleUrls: ['./landing-page-card.component.css'],
    standalone: false
})
export class LandingPageCardComponent implements OnInit {

  @Input() title: string;
  @Input() information: string;
  @Input() fragment: string;
  @Input() imgUrl: string;
  @Input() path : string;
  @Input() api: string="open";


  constructor() {
    this.title = "Card title";
    this.information = "Card description";
    this.fragment = "#";
    this.imgUrl = "assets/img/default-icon.png";
    this.path = 'trade';
  }

  ngOnInit(): void {
  }
  getRouteSegment() {
    if (this.api=='open') {
      return ['/rest-api-reference/']
    }if (this.api == 'fix') {
      return ['/fix-api-reference/']
    }if (this.api=='backOffice') {
      return ['/external-api-reference/']
    }else{
      return  []
    }

  }


}
